// extracted by mini-css-extract-plugin
module.exports = {"title":"e_vg","container":"e_wg","right":"e_xg","image":"e_yg","scoreLine":"e_zg","scoreRing":"e_Ag","badge":"e_Bg","badgeImage":"e_Cg","badgeRing":"e_Dg","large":"e_Eg"};